import type { WipPeriod } from "@src/__generated__/graphql";
import { action, computed, makeObservable, observable } from "mobx";
import type { TValue } from "./MonthPicker";

type TWipPeriodMixed = Pick<WipPeriod, "id"> & Pick<TValue, "month" | "year">;

export class WipPeriodsStore {
  @observable private _periodId?: WipPeriod["id"];

  @observable.ref options: TWipPeriodMixed[] = [];

  constructor() {
    makeObservable(this);
  }

  @computed get currentPeriod(): TWipPeriodMixed | undefined {
    if (this._periodId) {
      return this.options.find((i) => i.id === this._periodId);
    }

    return this.options[0];
  }

  @action
  setPeriodId(value: WipPeriodsStore["_periodId"]) {
    this._periodId = value;
  }

  @action
  setOptions(src: WipPeriod[]) {
    this.options = src
      .sort(
        (a, b) =>
          new Date(b.starts_at).getTime() - new Date(a.starts_at).getTime(),
      )
      .map((i) => {
        const date = new Date(i.starts_at);

        return {
          id: i.id,
          month: date.getMonth(),
          year: date.getFullYear(),
        };
      });
  }
}
